import { styled as o, Box as x, Typography as h } from "@mui/material";
import f from "../../../temp-lib/assets/icons/icon-okx.svg.js";
import g from "../../../temp-lib/assets/icons/icon-ronin.svg.js";
import k from "../../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import s from "../../../temp-lib/components/share/next/Image.js";
import { ChainAddressType as u } from "../../../temp-lib/constants/chain.js";
import { ERROR_CODE as w } from "../../../temp-lib/constants/error.js";
import { WalletType as a } from "../../../temp-lib/constants/web3.js";
import { useAccountContext as O } from "../../../temp-lib/contexts/account/AccountContext.js";
import { isIosOrAndroid as b, isOkxApp as p } from "../../../temp-lib/util/browser/index.js";
import { useCallback as y } from "react";
import { useTranslation as R } from "react-i18next";
import { jsxs as r, jsx as i } from "react/jsx-runtime";
const W = o(x)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 20px;
  padding: 40px;

  ${(t) => t.theme.breakpoints.down("res768")} {
    margin-top: 60px;
  }
`, C = o(h)`
  font-size: 28px;
  font-weight: 700;
`, m = o(k)`
  --background-color: #1473e9;
  max-height: 50px;
  border-radius: 4px;
  color: white;
  flex: 1;
  font-size: 16px;
  gap: 6px;
  height: 50px;
  margin-bottom: 20px;
  margin-left: auto;
  width: 100%;
  :hover {
    filter: brightness(0.9);
  }
`, I = o(s)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`, N = o(m)`
  --background-color: white;
  color: black;
  flex: 0.5;
  min-width: 140px;
`, B = o(s)`
  width: 24px;
  height: 24px;
`, K = ({
  onRoninLoginClick: t
}) => {
  const {
    t: e
  } = R(), {
    loginByWallet: l,
    setWrongNetwork: c
  } = O(), d = y(async () => {
    try {
      if (b() && !p()) {
        const n = "https://www.okx.com/download?deeplink=" + encodeURIComponent("okx://wallet/dapp/url?dappUrl=" + encodeURIComponent(location.href));
        window.location.href = n;
      } else
        await l(a.Okx, u.RONIN);
    } catch (n) {
      n.code === w.LOGIN.WRONG_NETWORK && c(a.Okx);
    }
  }, [l, c]);
  return /* @__PURE__ */ r(W, {
    children: [/* @__PURE__ */ i(C, {
      children: e("login.select_wallet.header")
    }), !p() && /* @__PURE__ */ r(m, {
      onClick: t,
      children: [/* @__PURE__ */ i(I, {
        src: g
      }), e("login.general.button.ronin")]
    }), /* @__PURE__ */ r(N, {
      onClick: d,
      children: [/* @__PURE__ */ i(B, {
        src: f
      }), e("login.general.button.okx")]
    })]
  });
};
export {
  K as default
};
//# sourceMappingURL=SelectWalletSection.js.map
